import { render, staticRenderFns } from "./ToBe.vue?vue&type=template&id=5a44a608&scoped=true&"
import script from "./ToBe.vue?vue&type=script&lang=js&"
export * from "./ToBe.vue?vue&type=script&lang=js&"
import style0 from "./ToBe.vue?vue&type=style&index=0&id=5a44a608&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a44a608",
  null
  
)

export default component.exports